import React from 'react';
import { compose } from 'recompose';

import { AdminPricing } from '@/components/admin/AdminPricing';
import { css } from '@emotion/react';
import { Context, ContextProvider } from './store';

const withContext = (Component) => (props) =>
    (
        <ContextProvider>
            <Component {...props} context={Context} />
        </ContextProvider>
    );

export default compose(withContext)(AdminPricing);
